import { ErrorHandler, Injectable } from '@angular/core';
import { LoggerProvider, LoggerEvent } from '../logger/logger';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor() { }

  handleError(errors) {
    // !!! VERY IMPORTANT !!!
    // Never use Redux here (store.dispatch) otherwise it can cause additional change detections which can cause problems when there are template errors which would result in repeated errors here

    if (errors) {
      if (errors.isArray) {
        errors.forEach(err => {
          // tslint:disable-next-line:no-console
          console.error(err); // tslint:disable-line
          this.logError(err);
        });
      }
      else {
        // tslint:disable-next-line:no-console
        console.error(errors); // tslint:disable-line
        this.logError(errors);
      }
    }
    else {
      LoggerProvider.error(this, LoggerEvent.UnhandledException, 'Unknown unhandled exception');
    }
  }

  logError(error) {
    let exception = null;
    try {
      exception = JSON.stringify(error, null, 2);
    }
    catch {
      exception = 'Unable to parse exception';
    }

    if (error.message && error.message.indexOf('ExpressionChangedAfterItHasBeenCheckedError:') === 0) {
      LoggerProvider.info(this, 'ExpressionChangedAfterItHasBeenCheckedError warning', error.message);
      return;
    } else if (error.message && error.message.indexOf('Uncaught (in promise): removeView was not found') === 0) {
      LoggerProvider.info(this, 'removeView was not found warning', error.message);
      return;
    }
    const log = LoggerProvider.error(this, LoggerEvent.UnhandledException, 'Unknown unhandled exception', exception);
    if (error.message) {
      LoggerProvider.context(log, LoggerEvent.ExceptionMessage, 'Unhandled exception message', error.message);
    }
    if (error.stack) {
      LoggerProvider.context(log, LoggerEvent.ExceptionStack, 'Unhandled exception stack', error.stack);
    }
  }
}


// WEBPACK FOOTER //
// ./src/providers/error/error-handler.ts